import { TokenTransactionMap } from "./tokenTransactionAction";

const initialState = {
  isLoading: false,
  transactionList: {},
  refreshTokenList: true,
  selectedVirtualToken: null,
  search: "",
  templates: [],
  searchText: "",
  skip: 0,
  limit: 10,
  transaction_type: "",
  status: "",
  fromDate: "",
  toDate: "",
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TokenTransactionMap.GET_ALL_TOKEN_TXN_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case TokenTransactionMap.GET_ALL_TOKEN_TXN_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        transactionList: action.payload,
        refreshTokenList: false,
      };
    }
    case TokenTransactionMap.GET_ALL_TOKEN_TXN_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshTokenList: false,
      };
    }

    case TokenTransactionMap.GET_TOKEN_TRANSACTION_START:
      return { ...state, isLoading: true };
    case TokenTransactionMap.GET_TOKEN_TRANSACTION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        selectedVirtualToken: action.payload.data,
      };
    case TokenTransactionMap.GET_TOKEN_TRANSACTION_ERROR:
      return {
        ...state,
        isLoading: false,
      };

    case TokenTransactionMap.ADD_TOKEN_TXN_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case TokenTransactionMap.ADD_TOKEN_TXN_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        refreshTokenList: true,
      };
    }
    case TokenTransactionMap.ADD_TOKEN_TXN_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshTokenList: false,
      };
    }
    case TokenTransactionMap.UPDATE_TOKEN_TXN_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case TokenTransactionMap.UPDATE_TOKEN_TXN_SUCCESS: {
      return {
        ...state,
        refreshTokenList: true,
      };
    }
    case TokenTransactionMap.UPDATE_TOKEN_TXN_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshTokenList: false,
      };
    }
    // case TokenTransactionMap.GET_ALL_TEMPLATES_START: {
    //   return {
    //     ...state,
    //     isLoading: true,
    //   };
    // }
    // case TokenTransactionMap.GET_ALL_TEMPLATES_SUCCESS: {
    //   return {
    //     ...state,
    //     isLoading: false,
    //     templates: action.payload,
    //     refreshTokenList: true,
    //   };
    // }
    // case TokenTransactionMap.GET_ALL_TEMPLATES_ERROR: {
    //   return {
    //     ...state,
    //     isLoading: false,
    //     templates: [],
    //     refreshTokenList: false,
    //   };
    // }
    // case TokenTransactionMap.SELECT_TOKEN_TXN_DETAILS: {
    //   return {
    //     ...state,
    //     isLoading: false,
    //     selectedVirtualToken: action.payload,
    //   };
    // }
    case TokenTransactionMap.SEARCH_TEXT_CHANGE: {
      return {
        ...state,
        searchText: action.payload,
      };
    }

    case TokenTransactionMap.SELECT_TEXT_CHANGE: {
      return {
        ...state,
        ...action.payload, // Merge the updated fields into the state
        refreshTokenList: true,
      };
    }
    case TokenTransactionMap.SET_TOKEN_TXN_BATCH_NUMBER: {
      return {
        ...state,
        skip: action.payload,
        refreshTokenList: true,
      };
    }
    case TokenTransactionMap.REFRESH_TOKEN_TXN_LIST: {
      return {
        ...state,
        skip: 0,
        refreshTokenList: true,
      };
    }
    // case TokenTransactionMap.DELETE_TOKEN_TXN_START: {
    //   return {
    //     ...state,
    //     isLoading: true,
    //   };
    // }
    // case TokenTransactionMap.DELETE_TOKEN_TXN_SUCCESS: {
    //   return {
    //     ...state,
    //     isLoading: false,
    //     refreshTokenList: true,
    //   };
    // }
    // case TokenTransactionMap.DELETE_TOKEN_TXN_ERROR: {
    //   return {
    //     ...state,
    //     isLoading: false,
    //     refreshTokenList: false,
    //   };
    // }
    case TokenTransactionMap.SET_TO_DATE_CHANGES: {
      return {
        ...state,
        toDate: action.payload,
        refreshTokenList: true,
      };
    }
    case TokenTransactionMap.SET_FROM_DATE_CHANGES: {
      return {
        ...state,
        fromDate: action.payload,
        refreshTokenList: true,
      };
    }
    case TokenTransactionMap.RESET_FILTERS: {
      return {
        ...state,
        toDate: "",
        fromDate: "",
        status: "",
        transaction_type: "",
        search: "",
        searchText: "",
        refreshTokenList: true,
      };
    }
    default:
      return { ...state };
  }
};
